import React, {Component} from 'react'
import queryString from "query-string"
import PropTypes from 'prop-types'
import {Select} from "antd"
import {listPartner} from "../../../services/api/3dApi"
import removeVietnameseTones from "../../../helpers/removeVietnameseTones"

const {Option} = Select

class SelectPartnerSewing extends Component {
    constructor(props) {
        super(props)

        this.state = {
            listPartner: []
        }
    }

    componentDidMount() {
        this._fetchPartnerSewing()
    }

    _fetchPartnerSewing = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                type: 'sewing_partner',
                hidden: false,
                limit: 1000
            }

            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {success, data, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                listPartner: data.partners
            })

            const {onLoaded} = this.props
            if (typeof onLoaded === 'function') {
                onLoaded(data.partners)
            }
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handleChangePartner = (value) => {
        const {onChangePartner} = this.props

        if (typeof onChangePartner === 'function') {
            onChangePartner(value)
        }
    }

    // searchByCode: tìm theo tên hoặc mã đối tác, không phân biệt dấu (màn Giao may ảnh)
    _filterOption = (input, option) => {
        const {searchByCode} = this.props

        if (!searchByCode) {
            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }

        const keyword = removeVietnameseTones(input).trim()
        return removeVietnameseTones(option.props.searchText || option.props.children).indexOf(keyword) >= 0
    }

    render() {
        const {listPartner, error} = this.state
        const {partner, searchByCode, invalid, hideLabel, size, className, dropdownClassName, dropdownAlign, placeholder, notFoundContent} = this.props
        // Có placeholder (màn Giao may ảnh): ô trống hiện placeholder + nút xoá, không dùng option rỗng
        const usePlaceholder = !!placeholder

        return (
            <div className={`SelectPartnerSewing ${className}`}>
                {!hideLabel && <label className='d-block'>Chọn đối tác may (<span className='text-danger'>* bắt buộc</span>)</label>}
                <Select
                    size={size}
                    value={usePlaceholder ? (partner || undefined) : partner}
                    placeholder={placeholder || undefined}
                    allowClear={usePlaceholder}
                    onChange={this._handleChangePartner}
                    className={`Custom${invalid ? ' is-invalid-partner' : ''}`}
                    showSearch
                    filterOption={this._filterOption}
                    dropdownClassName={dropdownClassName}
                    dropdownAlign={dropdownAlign}
                    notFoundContent={notFoundContent}
                >
                    {!usePlaceholder && <Option value=''>--- Chọn đối tác may ---</Option>}
                    {
                        listPartner.length > 0 && listPartner.map(item =>
                            <Option
                                key={item._id}
                                value={item._id}
                                title={item.name}
                                searchText={searchByCode ? `${item.name} ${item.code || ''}` : undefined}
                            >
                                {item.name}
                            </Option>
                        )
                    }
                </Select>

                {
                    error && <div className="text-danger mt-3">{error}</div>
                }
            </div>
        )
    }
}

SelectPartnerSewing.propTypes = {
    partner: PropTypes.string,
    onChangePartner: PropTypes.func,
    onLoaded: PropTypes.func,
    searchByCode: PropTypes.bool,
    invalid: PropTypes.bool,
    hideLabel: PropTypes.bool,
    size: PropTypes.string,
    className: PropTypes.string,
    dropdownClassName: PropTypes.string,
    dropdownAlign: PropTypes.object,
    placeholder: PropTypes.string,
    notFoundContent: PropTypes.node,
}

SelectPartnerSewing.defaultProps = {
    searchByCode: false,
    invalid: false,
    hideLabel: false,
    size: 'large',
    className: 'mb-3',
    dropdownClassName: 'custom-select-partner',
    // undefined → antd mặc định bung xuống (bottomLeft) cho các màn cũ
    dropdownAlign: undefined,
    placeholder: '',
    // undefined → giữ mặc định của antd ("No Data") cho các màn cũ
    notFoundContent: undefined,
}

export default SelectPartnerSewing
